import React, { useState } from 'react';
import { useForm, useApi } from 'hooks';
import { initialState } from './login.state';
import styles from './login.module.scss';
import { login } from 'apis';
import { Path, Event } from 'enums';
import { Field, TextField, PasswordField, Button, Highlight, Text, Title } from 'components/commons';
import locale from 'localization';
import { handleRequest } from 'utils';
import { useHistory } from 'react-router-dom';

const LoginForm = (props) => {
  const history = useHistory();

  const [incorrectCreds, setIncorrectCreds] = useState();

  const { request: loginRequest, loading: loggingIn } = useApi({
    api: login,
    handleOwnError: {
      badrequest: true
    }
  });

  const { fields, modifyField, submitForm, makeFormInvalid, getFormValues, applyFieldErrors } = useForm({
    initialState
  });

  const handleLogin = async () => {
    setIncorrectCreds(false);
    const { username, password } = getFormValues();
    if (!username || !password) {
      applyFieldErrors({
        username: !username ? '' : null,
        password: !password ? '' : null
      });
      return;
    }

    handleRequest(
      async () => {
        const res = await loginRequest({ username, password }, () => handleLogin());
        localStorage.setItem('accessToken', res.accessToken);
        localStorage.setItem('role', res.role);
        localStorage.setItem('username', username);
        localStorage.setItem('firstName', res.firstName);
        localStorage.setItem('lastName', res.lastName);
        history.push(Path.Dashboard);
      },
      null,
      (err) => {
        if (err.data?.errorCode === 'U0001') {
          makeFormInvalid();
          setIncorrectCreds(true);
          return applyFieldErrors({
            username: '',
            password: ''
          });
        }
        return err.showError();
      }
    );
  };

  return (
    <div className={styles.login}>
      <Title className={styles.title}>Accounting - Lucban Portal</Title>

      {incorrectCreds && (
        <Highlight error>
          <Text>{locale.theEnteredUsernamePassIncorrect}</Text>
        </Highlight>
      )}
      <Field {...fields.username}>
        <TextField {...fields.username} onChange={modifyField} />
      </Field>
      <Field {...fields.password}>
        <PasswordField
          {...fields.password}
          onChange={modifyField}
          onEnter={() => {
            submitForm(handleLogin);
          }}
        />
      </Field>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        {/* <div className={styles.remember}>
          <Checkbox {...fields.remember} onChange={modifyField} />
          {fields.remember.label}
        </div> */}
        {/* <div className={styles.forgotPassword}>
          <span
            onClick={() => {
              history.push(Path.ForgotPassword);
            }}
          >
            {locale.forgotPassword}
          </span>
        </div> */}
      </div>
      <Button
        primary
        className={styles.loginButton}
        loading={loggingIn}
        onClick={() => {
          submitForm(handleLogin);
        }}
        eventName={Event.LogIn}
      >
        {locale.logIn}
      </Button>
    </div>
  );
};

export default LoginForm;
